import {Component, HostBinding, HostListener, OnInit} from '@angular/core';
import {SettingsService} from "./core/settings/settings.service";
import {Title} from "@angular/platform-browser";
import {RmsService} from "../../projects/jv-common/src/lib/services/rms.service";
import {Router} from "@angular/router";

declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

    public loading = false;

    constructor(
        public settings: SettingsService,
        private titleService: Title,
        private rms: RmsService,
        private router: Router
    ) {
        this.titleService.setTitle(this.settings.getAppSetting('name'));
    }

    ngOnInit() {
        $(document).on('click', '[href="#"]', e => e.preventDefault());
        let widthWindow = $(window).width();
        if (widthWindow < 1200){
            this.settings.setLayoutSetting('isCollapsed', true);
        }
        this.rms.loggedOut.subscribe( rs => {
            this.router.navigateByUrl('login');
        })
    }

    @HostBinding('class.layout-fixed')
    get isFixed() {
        return this.settings.getLayoutSetting('isFixed');
    }

    @HostBinding('class.aside-collapsed')
    get isCollapsed() {
        return this.settings.getLayoutSetting('isCollapsed');
    }

    @HostBinding('class.layout-boxed')
    get isBoxed() {
        return this.settings.getLayoutSetting('isBoxed');
    }

    @HostBinding('class.layout-fs')
    get useFullLayout() {
        return this.settings.getLayoutSetting('useFullLayout');
    }

    @HostBinding('class.hidden-footer')
    get hiddenFooter() {
        return this.settings.getLayoutSetting('hiddenFooter');
    }

    @HostBinding('class.layout-h')
    get horizontal() {
        return this.settings.getLayoutSetting('horizontal');
    }

    @HostBinding('class.aside-float')
    get isFloat() {
        return this.settings.getLayoutSetting('isFloat');
    }

    @HostBinding('class.offsidebar-open')
    get offsidebarOpen() {
        return this.settings.getLayoutSetting('offsidebarOpen');
    }

    @HostBinding('class.aside-toggled')
    get asideToggled() {
        return this.settings.getLayoutSetting('asideToggled');
    }

    @HostBinding('class.aside-collapsed-text')
    get isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }
    @HostListener('window:resize', ['$event'])

    onResize(event){
        if (event.target.innerWidth < 1200){
            this.settings.setLayoutSetting('isCollapsed', true);
        }else{
            this.settings.setLayoutSetting('isCollapsed', false);
        }

    }

}
